import * as FeatureHubReact from '@feature-hub/react';
import * as ModuleLoaderAmd from '@feature-hub/module-loader-amd';
import * as React from 'react';
import * as audiColaQueryService from '@oneaudi/onegraph-query-service-v0';
import * as audiColaService from '@oneaudi/onegraph-service-v4';
import * as confiStateManagerService from '@oneaudi/confi-state-manager-service';
import * as oneGraphClient from '@oneaudi/onegraph-client';
import * as oneGraphClientv3 from '@volkswagen-onehub/onegraph-client';
import * as oneGraphQueryService from '@oneaudi/onegraph-query-service';
import * as oneGraphService from '@oneaudi/onegraph-service';

import { audiUiReact, audiUiReactV2 } from '../externals/audi-ui-react';

const definedExternals = async (): Promise<ModuleLoaderAmd.Externals> => {
  const [
    { axios },
    { cartService },
    { oneshopServiceApollo },
    { oneshopUserSessionService },
    { oneshopTenantService },
    { ReactDom },
    { styled },
  ] = await Promise.all([
    import(/* webpackChunkName: "axios" */ '../externals/axios'),
    import(/* webpackChunkName: "cart-service" */ '../externals/cart-service'),
    import(
      /* webpackChunkName: "urql-service" */ '../externals/oneshop-service-apollo'
    ),
    import(
      /* webpackChunkName: "user-session-service" */ '../externals/oneshop-user-session-service'
    ),
    import(
      /* webpackChunkName: "tenant-service" */ '../externals/oneshop-tenant-service'
    ),
    import(/* webpackChunkName: "react-dom" */ '../externals/react-dom'),
    import(
      /* webpackChunkName: "styled-components" */ '../externals/styled-components'
    ),
  ]);

  return {
    '@audi/audi-ui-react': audiUiReact,
    '@audi/audi-ui-react-v2': audiUiReactV2,
    '@feature-hub/module-loader-amd': ModuleLoaderAmd,
    '@feature-hub/react': FeatureHubReact,
    '@oneaudi/confi-state-manager-service': confiStateManagerService,
    '@oneaudi/onegraph-client': oneGraphClient,
    '@oneaudi/onegraph-query-service': oneGraphQueryService,
    '@oneaudi/onegraph-service': oneGraphService,
    '@volkswagen-one-hub/audi-cola-query-service': audiColaQueryService,
    '@volkswagen-onehub/audi-cola-service': audiColaService,
    '@volkswagen-onehub/onegraph-client': oneGraphClientv3,
    axios,
    'cart-service': cartService,
    react: React,
    'react-dom': ReactDom,
    'styled-components': styled,
    'tenant-service': oneshopTenantService,
    'urql-service': oneshopServiceApollo,
    'user-session-service': oneshopUserSessionService,
  };
};

const providedExternals = {
  '@audi/audi-ui-react': process.env.AUDI_UI_REACT_VERSION as string,
  '@audi/audi-ui-react-v2': process.env.AUDI_UI_REACT_V2_VERSION as string,
  '@feature-hub/module-loader-amd': process.env.FEATURE_HUB_VERSION as string,
  '@feature-hub/react': process.env.FEATURE_HUB_VERSION as string,
  '@oneaudi/confi-state-manager-service':
    process.env.SERVICE_CONFI_STATEMANAGER_VERION,
  '@oneaudi/onegraph-client': process.env.ONEGRAPH_CLIENT_VERSION_5 as string,
  '@oneaudi/onegraph-query-service':
    process.env.SERVICE_ONEGRAPH_QUERY_SERVICE_VERSION,
  '@oneaudi/onegraph-service': process.env.SERVICE_ONEGRAPH_SERVICE_VERSION,
  '@volkswagen-onehub/audi-cola-query-service': process.env
    .COLA_QUERY_SERVICE_VERSION as string,
  '@volkswagen-onehub/audi-cola-service': process.env
    .SERVICE_COLA_VERSION as string,
  '@volkswagen-onehub/onegraph-client': process.env
    .ONEGRAPH_CLIENT_VERSION_3 as string,
  axios: process.env.AXIOS_VERSION as string,
  'cart-service': process.env.VW_CART_SERVICE_VERSION as string,
  react: process.env.REACT_VERSION as string,
  'react-dom': process.env.REACT_DOM_VERSION as string,
  'styled-components': process.env.STYLED_COMPONENTS_VERSION as string,
  'tenant-service': process.env.VW_TENANT_SERVICE_VERSION as string,
  'urql-service': process.env.VW_URQL_SERVICE_VERSION as string,
  'user-session-service': process.env.VW_USER_SESSION_SERVICE_VERSION as string,
};

export { definedExternals, providedExternals };
